/**
 * `<before-after>` custom element (feature list v1.2).
 *
 * The native range input drives the clip between the two images via the
 * `--cut` custom property. Keyboard and touch come free with the input;
 * without JavaScript the frame stays at the 50/50 split.
 */
class BeforeAfter extends HTMLElement {
  connectedCallback() {
    const range = this.querySelector('[data-before-after-range]');
    if (!range) return;
    range.addEventListener('input', () => {
      this.style.setProperty('--cut', `${range.value}%`);
    });
  }
}

if (!customElements.get('before-after')) {
  customElements.define('before-after', BeforeAfter);
}
